import { render, staticRenderFns } from "./integralTextBoard.vue?vue&type=template&id=7deaf769&scoped=true"
import script from "./integralTextBoard.vue?vue&type=script&lang=js"
export * from "./integralTextBoard.vue?vue&type=script&lang=js"
import style0 from "./integralTextBoard.vue?vue&type=style&index=0&id=7deaf769&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deaf769",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7deaf769')) {
      api.createRecord('7deaf769', component.options)
    } else {
      api.reload('7deaf769', component.options)
    }
    module.hot.accept("./integralTextBoard.vue?vue&type=template&id=7deaf769&scoped=true", function () {
      api.rerender('7deaf769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/integralTextBoard.vue"
export default component.exports